import { render, staticRenderFns } from "./PartnerLogos.vue?vue&type=template&id=d410061a&"
import script from "./PartnerLogos.vue?vue&type=script&lang=js&"
export * from "./PartnerLogos.vue?vue&type=script&lang=js&"
import style0 from "./PartnerLogos.vue?vue&type=style&index=0&id=d410061a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports